
import {useEffect} from 'react';
import { Grid, Typography } from "@mui/material";
import Head from 'next/head';
import { useAuth } from '../contexts/AuthContext';
import { useHistory } from 'react-router-dom';
import { DashboardLayout } from './dashboard-layout';

const Pending = () => {
    const {retailerId} = useAuth(); 
    const history = useHistory();

    useEffect(() => {
        console.log("retailerId");
        console.log(retailerId);
    
        if(retailerId) {
            history.push("/orders");
        }
    }, []);    

    return (
        <>
            <Head>
                <title>
                    Pending
                </title>
            </Head>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '100vh' }}
                >
                <Grid item xs={3} p={1}>
                    <Typography variant="h6">Votre compte n'est associé à aucune enseigne pour le moment</Typography>                    
                </Grid>       
                <Grid item xs={3} p={1}>
                    <Typography variant="h6">Merci de demander à votre contact Loberz d'associer votre compte utilisateur</Typography>                                      
                </Grid>          
            </Grid> 
        </>
    );
}

Pending.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default Pending;